import React, { useEffect, useState } from "react";
import { Form, Spin, Modal, Input, DatePicker } from "antd";
import Utils from "../../../../../../shared/helpers/utils";
import { FormConfig } from "../../../../../../shared/config/GlobalConfig";
import moment from "moment";
import CuitFormItem from '../../../../../../shared/components/cuitFormItem';
import CampoObligatorio from "../../../../../../shared/components/campoObligatorio";

const FormItem = Form.Item;

const AnexoVResponsableDeUsoModal = props => {
  const [working, setWorking] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
  }, []);

  useEffect(() => {
    if(props.visible === true){ form.resetFields(); }
  }, [props.visible]);

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        props.onOk({ 
          Hash: props.responsable ? props.responsable.Hash : Utils.generateHash(), 
          ...values,
        });
      });
  }

  return (
    <Modal 
      title={`${props.responsable ? 'Editar' : 'Agregar'} Responsable de Uso`}
      width="60%"
      visible={ props.visible }
      onOk={ handleOk }
      onCancel={ props.onCancel }
    >
      <Spin spinning={ working }>
        <Form
          { ...FormConfig.DefaultLayout }
          form={ form }
          name="formulario"
          initialValues={{ ...props.responsable, 
            IdEquipoRadiologico: props.responsable?.IdEquipoRadiologico ? props.responsable.IdEquipoRadiologico : props.equipo?.IdEquipoRadiologico,
            FechaExpedicion: props.responsable ? moment(props.responsable.FechaExpedicion) : undefined,
            FechaVencimiento: props.responsable ? moment(props.responsable.FechaVencimiento) : undefined
          }}
          scrollToFirstError
        >
          { props.responsable?.IdResponsableDeUso ? <FormItem name="IdResponsableDeUso" label="Responsable de Uso" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          { props.equipo?.IdEquipoRadiologico ? <FormItem name="IdEquipoRadiologico" label="Equipo Radiologico" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          <CuitFormItem name="Cuil" label="Cuil" rules={ [...FormConfig.DefaultRules] } />

          <FormItem name="AutorizacionIndividual" label="Autorizacion Individual" rules={ FormConfig.DefaultRules }>
            <Input />
          </FormItem>

          <FormItem name="NroPermisoHabilitante" label="Nro Permiso Habilitante" rules={ FormConfig.DefaultRules }>
            <Input />
          </FormItem>

          <FormItem name="MatriculaProfesional" label="Matricula Profesional" rules={ FormConfig.DefaultRules }>
            <Input />
          </FormItem>

          <FormItem name="FechaExpedicion" label="Fecha Expedicion" rules={ FormConfig.DefaultRules }>
            <DatePicker style={ { width: '100%' } } format={ "DD/MM/YYYY" }/>
          </FormItem>

          <FormItem name="FechaVencimiento" label="Fecha Vencimiento" rules={ FormConfig.DefaultRules }>
            <DatePicker style={ { width: '100%' } } format={ "DD/MM/YYYY" }/>
          </FormItem>

          <CampoObligatorio/>
          
        </Form>
      </Spin>
    </Modal>
  );
}

export default AnexoVResponsableDeUsoModal;